import { useQuery, useMutation } from "@tanstack/react-query";
import {
  createAgOrderDetail,
  fetchAllAgOrderDetails,
  updateAgOrderDetail,
  fetchOneAgOrderDetail,
  deleteAgOrderDetail,
} from "services/agorderdetail";

export const useAllAgOrderDetails = (filters = {}, { enabled=true }) => {
  const query = useQuery({
    queryKey: ["all-orderdetail", filters],
    queryFn: () => {
      return fetchAllAgOrderDetails(filters);
    },
    enabled
  });
  return query;
};

export const useOneAgOrderDetail = (id, enabled = true) => {
  const query = useQuery({
    queryKey: ["one-orderdetail", id],
    queryFn: () => {
      if (id) {
        return fetchOneAgOrderDetail(id);
      }
      return null;
    },
    enabled: Boolean(id) && enabled,
  });
  return query;
};

export const useCreateAgOrderDetail = () => {
  return useMutation({
    queryKey: ["create-orderdetail"],
    mutationFn: (data) => createAgOrderDetail(data),
  });
};

export const useUpdateAgOrderDetail = () => {
  return useMutation({
    queryKey: ["update-orderdetail"],
    mutationFn: ({ id, data }) => updateAgOrderDetail(id, data),
  });
};

export const useDeleteAgOrderDetail = () => {
  return useMutation({
    queryKey: ["delete-orderdetail"],
    mutationFn: (id) => deleteAgOrderDetail(id),
  });
};
